export default "__VITE_ASSET__CJulHXSG__"